export enum ScheduleType {
  None = 0,
  Daily = 1,
  Hourly = 2,
}

export enum UserDisabilityPreference {
  Any,
  Only,
  None,
  Specific, // no support on BE
}

export interface IEmailSettings {
  emailLanguage: string | null;
  onlyMatchingFilterEmails: boolean;
  receiveEmails: boolean;
  scheduleType: ScheduleType;
}

export interface IGenericJobSettings {
  anyContractType: boolean;
  contractTypes: number[];
  anyProductionType: boolean;
  productionTypes: number[];
  anyProductionCountry: boolean;
  productionCountries: string[];
  anyCastingCountry: boolean;
  castingCountries: string[];
  maxPlayingAge: number | null;
  minPlayingAge: number | null;
}

export interface IAgentJobSettings extends IGenericJobSettings {}

export interface IPerformerJobSettings extends IGenericJobSettings {
  anyGender: boolean;
  genderIds: number[];
  anyAppearance: boolean;
  appearanceIds: number[];
  disabilityPreference: UserDisabilityPreference;
  disabilityIds: number[];
  minimumHeight: number | null;
  maximumHeight: number | null;
  anyEthnicity: boolean;
  ethnicBackgroundIds: number[];
  heritageAndEthnicityIds: number[];
}

export interface IJobSettings {
  performerSettings: IPerformerJobSettings | null;
  agentSettings: IAgentJobSettings | null;
}
